import { Auth } from 'modules/auth/Auth';
import { AutoSlider } from 'modules/auth/components/AutoSlider';
import { SidePaneLayout } from 'modules/layouts/SidePaneLayout/SidePaneLayout';
import { memo } from 'react';
import { useSlides } from 'shared/hooks/useSlides';

const AuthPage = memo(() => {
  const slides = useSlides();
  return (
    <SidePaneLayout sidePaneChildren={<AutoSlider slides={slides} slideDuration={3000} />}>
      <Auth />
    </SidePaneLayout>
  );
});

export default AuthPage;
